import { AsyncPipe, CurrencyPipe, DatePipe, NgTemplateOutlet } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { BlinkDirective, LoadingIndicatorDirective } from '@zero/shared/ui-directives';
import { ExanteUriPipe, PriceScalePipe } from '@zero/shared/ui-pipes';
import { InstrumentType } from '@zero/shared/util-models';
import { TradeFacade, TradingTimesService } from '@zero/trade/domain';
import { map } from 'rxjs';
import { AssetLinksComponent } from '../asset-links/asset-links.component';

@Component({
  selector: 'trade-multi-order-confirm-orders',
  imports: [
    AsyncPipe,
    AssetLinksComponent,
    TranslocoPipe,
    CurrencyPipe,
    DatePipe,
    NgTemplateOutlet,
    PriceScalePipe,
    BlinkDirective,
    LoadingIndicatorDirective,
    ExanteUriPipe,
  ],
  templateUrl: './multi-order-confirm-orders.component.html',
  styleUrl: './multi-order-confirm-orders.component.scss',
})
export class MultiOrderConfirmOrdersComponent {
  public readonly facade = inject(TradeFacade);
  readonly #tradingTimesService = inject(TradingTimesService);

  public readonly InstrumentType = InstrumentType;

  public sellOrderValidToDate$ = this.facade.holidays$.pipe(
    map(() => {
      const datePreset = this.#tradingTimesService.getValidToDatePreset(this.#tradingTimesService.getCurrentLocalDateTime());
      return new Date(Date.UTC(datePreset.getFullYear(), datePreset.getMonth(), datePreset.getDate()));
    }),
  );
}
